module.exports = __webpack_public_path__ + "img/decoplafond-ap.55f0acdc.png";